module.exports = __webpack_public_path__ + "media/images/application/template/logoslider/logo-dyson-526e32905f761a23516e16684e125274.png";